import { useMutation, useQuery } from "@tanstack/react-query";
import api from "../../utils/api";

// 양도할 ABO 인증
export const useActivityTransferCheckAbo = ({ eventScheduleIdx, toAbo, fromAbo }) => {
	return useQuery({
		retry: 0,
		queryKey: ["checkAbo", toAbo, fromAbo, eventScheduleIdx],
		queryFn: () => api.get(`/activity-transfer/abo?to_abo_number=${toAbo}&from_abo_number=${fromAbo}&event_schedule_idx=${eventScheduleIdx}`).then((data) => data.data),
		enabled: false,
		select: (data) => {
			return data;
		},
	});
};

// 보유한 액티비티 조회
export const useOwnedActivity = (eventScheduleIdx, uid) => {
	return useQuery({
		retry: 0,
		queryKey: ["ownedActivity", eventScheduleIdx, uid],
		queryFn: () => api.get(`/activity-transfer/owned-activity?event_schedule_idx=${eventScheduleIdx}&to_abo_number=${uid}`).then((data) => data.data),
		select: (data) => {
			return data;
		},
	});
};

// 양도받은 액티비티 리스트 조회
export const useTransferredActivityList = (eventScheduleIdx, uid) => {
	return useQuery({
		retry: 0,
		queryKey: ["transferredActivityList", eventScheduleIdx, uid],
		enabled: (eventScheduleIdx && uid) ? true : false,
		queryFn: () => api.get(`/activity-transfer/list?event_schedule_idx=${eventScheduleIdx}&to_abo_number=${uid}`).then((data) => data.data),
		select: (data) => {
			if (data?.code == 0) {
				const result = [];
				// 양도 횟수가 0인 액티비티 필터링
				data.data?.map((el) => {
					if (el.activity_list.filter((v) => v.transfer_count > 0).length > 0) {
						result.push({
							...el,
							activity_list: el.activity_list.filter((v) => v.transfer_count > 0),
						});
					}
				});

				return {
					...data,
					data: result,
				};
			}

			return data;
		},
	});
};

// 액티비티 양도
export const useTransferActivity = () => {
	return useMutation({
		mutationKey: ["transferActivity"],
		mutationFn: (payload) => api.post("/activity-transfer", payload),
	});
};

// 양도 받은 액티비티 상태 변경
export const useTransferredActivityDecision = () => {
	return useMutation({
		mutationKey: ["transferredActivityDecision"],
		mutationFn: (payload) => api.post("/activity-transfer/decision", payload),
	});
};

// 양도/양수 내역 전체 조회
export const useTransferHistory = (eventScheduleIdx, uid) => {
	return useQuery({
		retry: 0,
		queryKey: ["transferHistory", eventScheduleIdx, uid],
		enabled: (eventScheduleIdx && uid) ? true : false,
		queryFn: () => api.get(`/activity-transfer/history?event_schedule_idx=${eventScheduleIdx}&to_abo_number=${uid}`).then((data) => data.data),
		select: (data) => {
			return data?.data;
		},
	});
};
